import { render, staticRenderFns } from "./page-profile-vertical.vue?vue&type=template&id=ab2acc76"
import script from "./page-profile-vertical.vue?vue&type=script&lang=js"
export * from "./page-profile-vertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports